import { PageContainer } from './PageContainer'
import { PageHeader } from './PageHeader'

export function ProductPageShell({
  title,
  subtitle,
  actions,
  children,
  size = 'default',
  navigation,
}) {
  return (
    <PageContainer size={size}>
      <PageHeader title={title} subtitle={subtitle} actions={actions} minimal />
      {navigation}
      {children}
    </PageContainer>
  )
}
